jQuery(function ($) {
  const singleOpen = true;
  const duration   = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 0 : 200;

  $('.accordion-container').each(function (cIdx) {
    const $container = $(this);
    const $items     = $container.find('.accordion-item');
    const containerId = $container.attr('id') || `acc-${cIdx}`;

    // Ensure unique trigger/panel IDs inside this container
    $items.each(function (i) {
      const $item  = $(this);
      const $btn   = $item.find('.accordion-trigger').first();
      const $panel = $item.find('.accordion-panel, [role="region"]').first();

      const triggerId = `${containerId}-trigger-${i}`;
      const panelId   = `${containerId}-panel-${i}`;

      $btn.attr({ id: triggerId, 'aria-controls': panelId });
      $panel.attr({ id: panelId, 'aria-labelledby': triggerId });
    });

    const $triggers = $container.find('.accordion-trigger');

    function updateContainerState() {
      const anyOpen = $triggers.filter('[aria-expanded="true"]').length > 0;
      $container.toggleClass('has-open', anyOpen);
    }

    // Initialise from aria-expanded
    $triggers.each(function () {
      const $btn    = $(this);
      const $panel  = $container.find('#' + $btn.attr('aria-controls'));
      const expanded = $btn.attr('aria-expanded') === 'true';

      if (expanded) {
        $panel.removeAttr('hidden').show();
        $btn.closest('.accordion-item').addClass('is-open');
      } else {
        $panel.attr('hidden', '').hide();
        $btn.closest('.accordion-item').removeClass('is-open');
      }
    });
    updateContainerState();

    function setExpanded($btn, expanded) {
      const $panel = $container.find('#' + $btn.attr('aria-controls'));
      const $item  = $btn.closest('.accordion-item');

      $btn.attr('aria-expanded', String(expanded));

      if (expanded) {
        $item.addClass('is-open');
        $panel.removeAttr('hidden').stop(true, true).hide().slideDown(duration, updateContainerState);
      } else {
        $item.removeClass('is-open');
        $panel.stop(true, true).slideUp(duration, function () {
          $panel.attr('hidden', '');
          updateContainerState();
        });
      }
    }

    function toggle($btn) {
      const expanded = $btn.attr('aria-expanded') === 'true';
      if (singleOpen && !expanded) {
        $triggers.not($btn).each(function () { setExpanded($(this), false); });
      }
      setExpanded($btn, !expanded);
    }

    $container.on('click', '.accordion-trigger', function (e) {
      e.stopPropagation();
      toggle($(this));
    });

    $container.on('click', '.accordion-item .title', function (e) {
      if ($(e.target).closest('.accordion-trigger').length) return;
      const $btn = $(this).find('.accordion-trigger').first();
      if ($btn.length) toggle($btn);
    });

    $container.on('keydown', function (e) {
      const $focused = $(document.activeElement);
      const $triggers = $container.find('.accordion-trigger'); // re-query (safe)
      const i = $triggers.index($focused);
      if (i === -1) return;

      if (e.key === 'ArrowDown') { e.preventDefault(); $triggers.eq((i + 1) % $triggers.length).focus(); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); $triggers.eq((i - 1 + $triggers.length) % $triggers.length).focus(); }
      else if (e.key === 'Home') { e.preventDefault(); $triggers.eq(0).focus(); }
      else if (e.key === 'End') { e.preventDefault(); $triggers.eq($triggers.length - 1).focus(); }
    });
  });
});
